import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    header_container: {
        backgroundColor: theme.palette.secondary.light,
        padding: '12px 16px',
        boxSizing: 'border-box',
        width: '100%',
        height: '60px',
        zIndex: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        borderBottom: `2px solid ${theme.palette.secondary.dark}`
    },
    logo_container: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        transition: 'transform 0.2s ease',
        '&:hover': {
            transform: 'scale(1.02)'
        }
    },
    rigth_btn_container: {
        display: 'flex',
        flexDirection: 'row',
        gap: '12px',
        alignItems: 'center',
        '& > *': {
            transition: 'transform 0.2s ease',
            '&:hover': {
                transform: 'translateY(-2px)'
            }
        }
    },
    no_hover:{
        '&:hover': {
            transform: 'none'
        }
    },
    logout_btn: {
        marginTop: '-5px'
    }
}));

export {useStyles}
